/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { MappingId } from "../../commons/types/MappingId";
import { UserId } from "../../commons/types/UserId";
import { MappingRuleConfig } from "./MappingRuleConfig";
export const MappingRuleOrConfig = core.serialization
    .object({
    id: MappingId.optional(),
    confidence: core.serialization.number().optional(),
    createdBy: UserId.optional(),
    createdAt: core.serialization.date().optional(),
    updatedAt: core.serialization.date().optional(),
    deletedAt: core.serialization.date().optional(),
})
    .extend(MappingRuleConfig);
